import { Stack } from 'expo-router';

export default function TenantManagementLayout() {
  return (
    <Stack
      screenOptions={{
        headerShown: false
      }}
    >
      <Stack.Screen name={'index'} />
      <Stack.Screen name={'[id]'} />
    </Stack>
  );
}
